import { Component, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { orgDataForHeader } from 'src/app/STORE/selectors/orgmanagement.selector';
import { ApiConstants } from 'src/app/base/api-constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import * as utilEnum from 'src/app/services/util.enum';
import { UtilService } from 'src/app/services/util.service';
@Component({
  selector: 'vb-pre-validation-tbl-view',
  templateUrl: './pre-validation-tbl-view.component.html',
  styleUrls: ['./pre-validation-tbl-view.component.scss'],
  standalone: false  //NOSONAR
})
export class PreValidationTblViewComponent implements OnInit {
  private modalRef = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);
  private appGlobalService = inject(AppGlobalService);
  private util = inject(UtilService);
  private store = inject(Store);
  private baseService = inject(HttpBaseService);

  files: any;
  cols: any = [];
  validationStatus = {
    WARNING: 'Warning',
    ERROR: 'Error',
    INFO: 'Information'
  };
  messageBundle: any;
  applicationMetaData: any;
  generationLog: any;
  lastPublishName = '';
  cloudBuildId = '';
  compilationFailed = false;
  showLogPopUp = false;
  logsArray = null;
  validationType = null;
  isContinue = false;

  closePopup(action?: any) {
    if (action) {
      this.modalRef.close(true);
    } else {
      this.modalRef.close(false);
    }
    this.modalRef.destroy();
  }

  closeLogPopup() {
    this.showLogPopUp = false;
    this.logsArray = null;
  }

  enrichMsg(additionalInfo, msg) {
    if (additionalInfo) {
      if (additionalInfo.buttonPath) {
        let pagesTemp = additionalInfo.buttonPath?.split('-->') || [];
        const values: any[] = [];
        pagesTemp.map((k: any) => {
          if (this.applicationMetaData[k] != null)
            values.push(this.util.getNameUsingMetaInfo(this.applicationMetaData, k));
          else
            values.push(k);
        });
        additionalInfo.buttonPath = values.join(' --> ');
      }
      if (additionalInfo?.workflowActor) {
        const actors = additionalInfo?.workflowActor?.split('_$_') || [];
        const d: any = [];
        actors?.map((o: string) => {
          d.push(this.util.getNameUsingMetaInfo(this.applicationMetaData, o) || null);
        });
        const index = d.findIndex((actor) => actor === 'Default Role ');
        if (index !== -1) {
          d[index] = 'App Admin';
        }
        const transformedWorkflowActor = d.join(', ');
        if (msg) {
          msg = msg.replace('{workflowActor}', transformedWorkflowActor);
        }
      }
      const replacements = this.util.formReplacementsObj(additionalInfo);
      let res = '';
      if (msg) {
        res = msg.replace(new RegExp(Object.keys(replacements).join('|'), 'g'), (matched) => replacements[matched]);
      }
      return res;
    }
    return msg;
  }

  getUsedInColumn(validationData: any, metadata: any) {
    const generatedPath: any = [];
    const pathData = this.generateOrderPath(validationData, metadata);
    const pathOrder = pathData.path
      ?.split('/')
      .filter((elm) => elm !== null && elm !== undefined && elm !== '' && elm !== 'undefined');
    const pathtypeOrder = pathData.typePath
      ?.split('/')
      .filter((elm) => elm !== null && elm !== undefined && elm !== '' && elm !== 'undefined');
    pathOrder.map((p: string, index: number) => {
      generatedPath.push({
        key: this.util.getNameUsingMetaInfo(metadata, p) || utilEnum.PropertyType[p] || p,
        type: pathtypeOrder[index] ? this.util.snakeToTitleCase(pathtypeOrder[index]) : null
      });
    });
    return generatedPath;
  }

  generateOrderPath(validationData: any, md: any) {
    let path = '';
    let typePath = '';
    const type = validationData.modelType;
    const ai = validationData.modelAdditionalInfo ? { ...validationData.modelAdditionalInfo } : {};
    switch (type) {
      case utilEnum.modelType.TABLE:
        if (ai?.propertyName === 'SCREEN_INTERIM_PAGE') {
          path = `${ai.pageName}`;
          typePath = `Page`;
        } else if (ai?.propertyName === 'PARENT_TABLE') {
          // For PARENT_TABLE, use childTableName instead of tableName
          path = `${ai?.childTableName}/${ai?.propertyName}`;
        } else if (ai?.templateName) {
          path = `${ai.tableName}/${ai?.propertyName}/${ai?.templateName}`;
        } else {
          path = `${ai.tableName}/${ai?.propertyName}/${ai?.templateName}`;
        }
        typePath = typePath || `Table/Property`;
        break;
      case utilEnum.modelType.TABLE_ACL:
        path = `${ai.tableName}/${ai?.propertyName}`;
        typePath = `Table/Property`;
        break;
      case utilEnum.modelType.QUERY_STRING:
        path = `Query Strings`;
        typePath = `QueryStrings`;
        break;
      case utilEnum.modelType.FIELD:
        if (ai?.propertyName === 'SCREEN_INTERIM_PAGE') {
          if (ai?.pageType === 'detail') {
            path = `${ai.pageName}/Form/${ai.fieldName}`;
            typePath = `Page/Section/Form Field`;
          } else if (ai?.pageType === 'list') {
            path = `${ai.pageName}/Grid/${ai.fieldName}`;
            typePath = `Page/Section/Grid Column`;
          } else {
            path = `${ai.pageName}/${ai.fieldName}`;
            typePath = `Page/Field`;
          }
        } else {
          path = `${ai.tableName}/${ai.fieldName}/${ai?.propertyName}`;
          typePath = `Table/Field/Property`;
        }
        break;
      case utilEnum.modelType.INDEX:
        path = `${ai.tableName}/${ai.foreignKey}`;
        typePath = `Table/Foreign Key`;
        break;
      case utilEnum.modelType.PAGE:
        path = `${ai.pageName ? ai.pageName : 'Pages'}`;
        typePath = `Page`;
        if (ai?.path) {
          path += ai?.path;
          ai.path.split('/').forEach((typ, i) => {
            if (i !== 0) {
              typePath += '/Node';
            }
          });
        }
        if (ai?.propertyName === 'Page Variables') {
          path += '/Page/Page Variables';
          typePath += '/Page/Node/Property';
        } else if (ai?.propertyName === 'Lookup') {
          path += `/${ai?.fieldName}`;
          typePath += '/Form Field';
        } else if (ai?.propertyName) {
          path += `/${ai?.propertyName}`;
          typePath += '/Property';
        } else if (ai?.NodeName) {
          path += `/${ai?.NodeName}`;
          typePath += '/Property';
        }
        break;
      case utilEnum.modelType.TECHNOLOGY_CHOICES:
        if (ai?.environmentName) {
          path = `${utilEnum.ComponentType.APP_SETTINGS}/${ai?.environmentName}/${ai?.propertyName}`;
          typePath = `Component/Environment/Property`;
        } else {
          path = `${utilEnum.ComponentType.APP_SETTINGS}/${ai?.propertyName}`;
          typePath = `Component//Property`;
        }
        break;
      case utilEnum.modelType.WORKFLOW:
        if (ai?.workflowActor) {
          const actors =
            this.util.getNameUsingMetaInfo(this.applicationMetaData, ai?.workflowActor)?.split('_$_') || [];
          const d: any = [];
          actors?.map((o: string) => {
            d.push(this.util.getNameUsingMetaInfo(this.applicationMetaData, o) || null);
          });
          const index = d.findIndex((actor) => actor === 'Default Role ');
          if (index !== -1) {
            d[index] = 'App Admin';
          }
          ai.workflowActor = d.join(', ');
        }
        if (ai?.workflowName && ai?.workflowStep && ai?.workflowActor && ai?.workflowAction) {
          path = `${ai?.workflowName}/${ai?.workflowStep}/${ai?.workflowActor}/${ai?.workflowAction}/${ai?.propertyName}`;
          typePath = `Workflow/Workflow Status/Workflow Actor/Workflow Action/Property`;
        } else if (ai?.workflowName && ai?.workflowStep && ai?.workflowActor) {
          path = `${ai?.workflowName}/${ai?.workflowStep}/${ai?.workflowActor}/${ai?.propertyName}`;
          typePath = `Workflow/Workflow Status/Workflow Actor/Property`;
        } else if (ai?.workflowName) {
          path = `${ai?.workflowName}/${ai?.propertyName}`;
          typePath = `Workflow/Property`;
        } else {
          path = `${ai?.propertyName}`;
          typePath = `Property`;
        }
        break;
      case utilEnum.modelType.ROLE:
        path = utilEnum.ComponentType.ROLES;
        typePath = ``;
        break;
      case utilEnum.modelType.GIT: {
        const orgSub = this.store.select(orgDataForHeader).subscribe((orgData: any) => {
          if (orgData) {
            const orgName = orgData?.name;
            if (orgName) {
              path = `${orgName}/${utilEnum.modelType.GIT}/${ai?.propertyName}`;
              typePath = `Organization/Git/Property`;
            } else {
              path = `Organization/${utilEnum.modelType.GIT}/${ai?.propertyName}`;
              typePath = `Organization/Git/Property`;
            }
            if (orgSub) {
              orgSub.unsubscribe();
            }
          }
        });
        break;
      }
      case utilEnum.modelType.APIINFO:
        path = `${ai.providerName}/${ai?.functionalComponent}/${ai?.APIName}`;
        typePath = `Provider/Functional Component/API`;
        break;
      case utilEnum.modelType.PROVIDER:
             path = `${ai.providerName}`;
             typePath = `Provider`;
             break;
      case utilEnum.modelType.SERVICE:
        path = `Services/${ai.tableName}/${ai?.serviceName}`;
        typePath = `Services/Table/Service`;
        break;
      default:
        path = `${ai.propertyName}`;
        typePath = `Property`;
    }
    return {
      path: path,
      typePath: typePath
    };
  }

  setData(data) {
    this.files = data
      .map((dt) => {
        let additionalInfo;
        for (const info in dt?.modelAdditionalInfo) {
          const value = this.util.getNameUsingMetaInfo(this.applicationMetaData, dt?.modelAdditionalInfo[info]);
          additionalInfo = { ...additionalInfo, ...{ [info]: value ? value : dt?.modelAdditionalInfo[info] } };
        }
        additionalInfo = {
          ...additionalInfo,
          ...{ modelId: this.util.getNameUsingMetaInfo(this.applicationMetaData, dt.modelId) }
        };
        dt.problemDesc = this.enrichMsg(additionalInfo, this.messageBundle[`${dt.errorCode}_P`]);
        dt.problemSol = this.enrichMsg(additionalInfo, this.messageBundle[`${dt.errorCode}_S`]);
        dt.usedIn = this.getUsedInColumn(dt, this.applicationMetaData);
        return dt;
      })
      .sort((a, b) => {
        const x = a.type.toLowerCase();
        const y = b.type.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
  }

  logSubscription() {
    const promise = new Promise<void>((resolve, reject) => {
      const ref$ = this.baseService
        .get({ ...ApiConstants.getCloudLogs, ...{ showSpinner: true } }, { cloudBuildId: this.cloudBuildId }, 'text')
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },
          error: (err: any) => {
            reject(err);
          },
          complete: () => {
            console.log('complete');
          }
        });
    });
    return promise;
  }

  getCloudBuildLog() {
    this.logSubscription().then(
      (value: any) => {
        console.log(value);
        this.showLogPopUp = true;
        this.logsArray = value.split('\n');
      },
      (error) => {
        console.log('error');
      }
    );
  }

  ngOnInit(): void {
    this.cols = [
      { field: 'type', header: 'PREVALIDATION_HEADER_TYPE' },
      { field: 'usedIn', header: 'PREVALIDATION_HEADER_COMPONENT' },
      { field: 'problemDesc', header: 'PREVALIDATION_HEADER_PBM_DESCRIPTION' },
      { field: 'problemSol', header: 'PREVALIDATION_HEADER_PROBLEM_SOLVE' }
    ];
    this.messageBundle = this.appGlobalService.get('prevalidationMessageBundle');
    this.applicationMetaData = this.appGlobalService.get('appmetaInfo');
    const data = this.config.data.prevalidationList;
    if (data) {
      this.generationLog = data?.generationLog;
      this.validationType = data?.type;
      this.lastPublishName = this.applicationMetaData[this.generationLog?.modifiedBy]
        ? this.applicationMetaData[this.generationLog?.modifiedBy]
        : null;
      if (this.validationType === 'cudConfig' || this.validationType === 'qvTableValidation') {
        this.applicationMetaData = { ...this.applicationMetaData, ...data?.aiMetaData };
      }
      this.setData(data.preValicationList);
      if (this.validationType === 'cudConfig' || this.validationType === 'qvTableValidation') {
        this.isContinue = this.files.filter((d) => d.type === 'ERROR').length === 0;
      }
      if (this.generationLog?.compilationStatus === 'COMPILATION_FAILED') {
        this.cloudBuildId = this.generationLog.compilationBuildId;
        this.compilationFailed = true;
      }
    }
  }
}
